import { isDateComplete } from "../dateAndTime";
import { calculateAge, formatDateForInput } from "./dateAndTime";

export const EDIT_MODE_MINOR_AGE_THRESHOLD = 18;
export const ADD_MODE_EMAIL_AGE_THRESHOLD = 13;

function normalizeDobValue(dob) {
  if (!dob) {
    return null;
  }

  if (isDateComplete(dob)) {
    return dob;
  }

  const formatted = formatDateForInput(dob);
  return formatted || dob;
}

export function getMemberAgeYears({ dob, currentAge, fallbackDob } = {}) {
  if (currentAge !== null && currentAge !== undefined && currentAge !== "") {
    const parsed = parseFloat(currentAge);
    if (!Number.isNaN(parsed)) {
      return parsed;
    }
  }

  const dobToCheck = normalizeDobValue(dob) || normalizeDobValue(fallbackDob);
  if (dobToCheck && isDateComplete(dobToCheck)) {
    const age = parseFloat(calculateAge(dobToCheck));
    return Number.isNaN(age) ? null : age;
  }

  return null;
}

export function isEditModeMinor({ isEditMode, dob, currentAge, fallbackDob }) {
  if (!isEditMode) {
    return false;
  }

  const age = getMemberAgeYears({ dob, currentAge, fallbackDob });
  return age !== null && age < EDIT_MODE_MINOR_AGE_THRESHOLD;
}

export function isEmailRequiredForMember({
  isEditMode,
  isDeceased,
  dob,
  currentAge,
  fallbackDob,
}) {
  if (isDeceased) {
    return false;
  }

  const age = getMemberAgeYears({ dob, currentAge, fallbackDob });
  if (age === null) {
    return true;
  }

  const threshold = isEditMode
    ? EDIT_MODE_MINOR_AGE_THRESHOLD
    : ADD_MODE_EMAIL_AGE_THRESHOLD;
  return age >= threshold;
}

export function getPrimaryFallbackDob(editMemberData) {
  if (!editMemberData) {
    return null;
  }

  return (
    editMemberData?.userData?.dob ||
    editMemberData?.dob ||
    editMemberData?.dateOfBirth ||
    null
  );
}

export function getSpouseFallbackDob(editMemberData) {
  if (!editMemberData) {
    return null;
  }

  return editMemberData?.spouseDob || editMemberData?.spouse_dob || null;
}
